import { User, UserService } from '@ospace/auth'
import { Button } from '@mantine/core'
import { showNotification } from '@ospace/shared'
import { useMutation } from 'react-query'

type ReinviteButtonProps = {
  user: User
}

export const ReinviteButton = (props: ReinviteButtonProps) => {
  const { user } = props
  const mutation = useMutation(
    (identityId: any) => {
      return UserService.inviteUser(identityId)
    },
    {
      onSuccess: () => {
        showNotification({
          message: 'The re-invitation was sent successfully.',
          type: 'success',
        })
      },
      onError: (e: any) => {
        showNotification({
          message: e.response?.data || e.message,
          type: 'error',
        })
      },
    }
  )

  const onInviteUser = async () => {
    const userEmail = user?.userAttributes.find((attr: any) => attr.Name === 'email')?.Value
    await mutation.mutateAsync(userEmail)
  }

  return (
    <Button
      onClick={onInviteUser}
      className='btn btn-sm btn-secondary me-2 float-right'
      disabled={mutation?.isLoading}
    >
      {mutation.isLoading && (
        <span className='spinner-border spinner-border-sm align-middle me-2' />
      )}
      Reinvite
    </Button>
  )
}
